__turbopack_context__.v({
  "footerContainer": "yOfhZq_footerContainer",
  "footerHeader": "yOfhZq_footerHeader",
  "footerSubHeader": "yOfhZq_footerSubHeader",
});
